export default "__VITE_PUBLIC_ASSET__18fd3b36__"